import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { format } from "date-fns";
import { LangContext } from "../LangContext.jsx";
class MyDossierFileItem extends Component {
  static contextType = LangContext;

  render() {
    const { file } = this.props;
    return (
      <tr>
        <td>
          <img src={"/assets/img/" + window.getMimeSVG(file.extension != undefined && file.extension.length > 0 ? file.extension : file.path)} />
        </td>
        <td>
          {file.file.title}
        </td>
        <td>{format(new Date(file.updated_at), 'dd/MM/yyyy')}</td>

        <td className="text-right">
          <a target="_blank" href={"/files/" + file.file.id} className="btn btn-icon btn-light btn-xs mr-5">
            <i className="flaticon2-download text-primary"></i>
          </a>
        </td>
      </tr>
    );
  }
}

export default MyDossierFileItem;

if (document.getElementById('MyDossierFileItem')) {
    ReactDOM.render(<MyDossierFileItem />, document.getElementById('MyDossierFileItem'));
}
